import { render, staticRenderFns } from "./RegimenGridScheduleEdit.vue?vue&type=template&id=1925a433"
import script from "./RegimenGridScheduleEdit.vue?vue&type=script&lang=js"
export * from "./RegimenGridScheduleEdit.vue?vue&type=script&lang=js"
import style0 from "./RegimenGridScheduleEdit.vue?vue&type=style&index=0&id=1925a433&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports